import PropTypes from 'prop-types';

// Display replacement for rrf's `<Errors>`. Renders the current messages out of
// react-hook-form's `formState.errors`, in the same wrapper/markup rrf produced
// (a `<div className="errors">` of `<span>` messages by default).
//
// Pass `names` to pin the order / limit which fields show (mirrors rrf listing a
// model); omit it to render every errored field. Default params (not
// defaultProps) because React 19 ignores defaultProps on function components.
export default function ValidationErrors({
  errors = {},
  names,
  className = 'errors',
  component: Component = 'span',
  wrapper: Wrapper = 'div',
}) {
  const fields = names && names.length ? names : Object.keys(errors);
  const messages = fields
    .map(name => (errors[name] ? { name, message: errors[name].message } : null))
    .filter(entry => entry && entry.message);

  if (!messages.length) return null;

  return (
    <Wrapper className={className}>
      {messages.map(({ name, message }) => (
        <Component key={name}>{message}</Component>
      ))}
    </Wrapper>
  );
}

ValidationErrors.propTypes = {
  errors: PropTypes.object,
  names: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  component: PropTypes.elementType,
  wrapper: PropTypes.elementType,
};
